import { Box, Grid, Typography } from '@mui/material'
import React from 'react'
import { useAppSelector } from '../../Redux/store';
import { ClientBookmarks } from './Components/ClientBookmarks';
import { TalentBookmarks } from './Components/TalentBookmarks';
import { KaziLayout } from '../../Shared Components/Kazi/Layouts/KaziLayout';
import { useGetManyTalentsQuery, useGetTalentQuery } from '../../Redux/api/talentApi';
import { useGetManyJobsQuery } from '../../Redux/api/jobApi';
import { skipToken } from '@reduxjs/toolkit/query';
import { useGetClientQuery } from '../../Redux/api/clientApi';
import { BookmarkBorderOutlined } from '@mui/icons-material';

export const Bookmarks = () => {
    /* ******************** Hooks ******************** */
    const userId = useAppSelector( state => state.Global.userId);
    const userType = useAppSelector( state => state.Global.userType);
    const isClient = userType === 'client';
    // Get talent bookmarks
    const {
        data: talentData, 
        isLoading: talentDataLoading, 
        isFetching: talentDataFetching
    } = useGetTalentQuery((!isClient && userId) || skipToken);
    const {
        data: jobs,
        isLoading: jobsLoading,
        isFetching: jobsFetching
    } = useGetManyJobsQuery(talentData?.bookmarked_jobs || skipToken);

    // Get client bookmarks
    const {
        data: clientData, 
        isLoading: clientDataLoading, 
        isFetching: clientDataFetching
    } = useGetClientQuery((isClient && userId) || skipToken);    
    const {
        data: talents, 
        isLoading: talentsLoading, 
        isFetching: talentsFetching
    } = useGetManyTalentsQuery(clientData?.bookmarked_talents || skipToken);
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <KaziLayout>
            {
                (jobs?.length ?? 0) > 0 || ( talents?.length ?? 0) > 0 ?
                (isClient ? 
                <ClientBookmarks talents={talents} />:
                <TalentBookmarks jobs={jobs} />) :                
                <Grid display={'flex'} flexDirection={'column'}>
                    <Typography variant='lora-headline-small' marginBottom={'3%'}>Bookmarked {isClient? 'Talent' : 'jobs'}</Typography>
                    <Grid display={'flex'} flexDirection={'column'} gap={'20px'} alignItems={'center'}>
                        <BookmarkBorderOutlined sx={{ color: 'green.200', fontSize: '100px'}}/>
                        <Typography>You have not bookmarked any { isClient ? 'Talent profiles' : 'job postings'} yet</Typography>
                    </Grid>
                </Grid>
            }
        </KaziLayout>
    )
}